var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02.12_Etiqueta---impressao-sucesso",
    transform: "translate(-275.000000, -420.000000)",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(275.000000, 420.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128,0 C198.692448,0 256,57.307552 256,128 C256,198.692448 198.692448,256 128,256 C57.307552,256 0,198.692448 0,128 C0,57.307552 57.307552,0 128,0 Z M128,2 C58.4121215,2 2,58.4121215 2,128 C2,197.587878 58.4121215,254 128,254 C197.587878,254 254,197.587878 254,128 C254,58.4121215 197.587878,2 128,2 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,103 C68.5522847,103 69,103.447715 69,104 L69,151 L188,151 C188.552285,151 189,151.447715 189,152 C189,152.552285 188.552285,153 188,153 L68,153 C67.4477153,153 67,152.552285 67,152 L67,104 C67,103.447715 67.4477153,103 68,103 Z",
    id: "Combined-Shape",
    transform: "translate(128.000000, 128.000000) rotate(-45.000000) translate(-128.000000, -128.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinish);
export default __webpack_public_path__ + "static/media/finish.b2a06e370e66846aff24e59eaf67f464.svg";
export { ForwardRef as ReactComponent };